enum ResponseMessageTypes {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    INFO = 'info'
}

enum KeyboardEvents {
    CUT = 'cut',
    COPY = 'copy',
    PASTE = 'paste',
    KEY_DOWN = 'keyDown',
    KEY_UP = 'keyUp',
    KEY_PRESS = 'keyPress'
}
enum VarianceInvestigationStatus {
    OPENED = 'Opened',
    CLOSED = 'Closed',
    Investigation = 'Investigation',
    DISCIPLINARY = "Disciplinary"
}

enum RestfulMethods {
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    GET = 'GET'
}
enum ApprovalMode {
    PHONE = 'PHONE',
    DOCUMENT = 'DOCUMENT',
    MAIL = 'MAIL'

}
enum QuotationStatus {
    OPEN = 'OPEN',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    APPROVED = 'Approved',
    INPROGRESS = 'INPROGRESS',

}
enum TestRunPeroid {
    //commented on 28-07-2020 for client issues, as they wanted to be renamed for daily and weekly..
    DAILY = 'Daily',
    WEEKLY = 'Weekly',
    // DAILY = 'SameDay',
    // WEEKLY = 'Dated',
    MONTHLY = 'Monthly',
    YEARLY = 'Yearly'
}
enum StockTakeStatus {
    PENDING = 'Pending',
    INITIATE = 'Initiate',
    CANCEL = 'Cancel'
}

enum RawLeadStatus {
    New = 1,
    UnAllocated = 2,
    Allocated = 3,
    FollowUp = 4,
    Escalated = 5,
    Archived = 6,
    Lead_Created = 7
}

enum NoSales {
    No_Sale = 2,
    Decline = 4
}

enum ModuleName {
    CUSTOMER = 'customer',
    LEAD = 'lead'
}

enum BoundaryTypes {
    OPERATIONS = 1,
    TECHNICAL = 2,
    LSS = 3,
    SALES = 4,
    OTHERS = 5
}


enum StatusName {
    ALLOCATED = 'allocated',
    AVAILABLE = 'available',
    DISPATCHED = 'dispatched',
    ARRIVED = 'arrived',
    DNR = 'dnr',
    LONGONSITE = 'longonsite'
}

enum StatusClass {
    STATUS_LABEL_GREEN = 'status-label-green',
    STATUS_LABEL_RED = 'status-label-red',
    STATUS_LABEL_BLUE = 'status-label-blue',
    STATUS_LABEL_ORANGE = 'status-label-orange',
    STATUS_LABEL_YELLOW = 'status-label-yellow',
    STATUS_LABEL_PINK = 'status-label-pink',
}

enum ChatEvents {
    NEW_MESSAGE = 'newMessage',
    GET_ONLINE_USERS = 'getOnlineusers',
    USER_DETAILS = 'userDetails',
    ADDED_IN_GROUP = 'addedingroup',
    BROADCAST_CREATED = 'bradcastCreated',
    DOCUMENT_RECEIVED = 'documentReceived',
    REMOVED_FROM_GROUP = 'removedFromGroup',
    ON_DISCONNECT = 'onDisconnect',
}

enum ChatInvoke {
    LEAVE_GROUP = "LeaveGroup",
    JOIN_GROUP = "joinGroup",
    CREATE_GROUP = "createGroup",
    SEND_TO_GROUP = "sendToGroup",
    CREATE_BOARDCAST = "createBradcast",
    SEND_TO_BOARDCAST = "sendToBroadcast",
    SEND_MESSAGE = "sendMssage",
    UPDATE_READ_MESSAGE = 'UpdateReadMessage'
}

export {
    ResponseMessageTypes, ModuleName, KeyboardEvents, VarianceInvestigationStatus, RestfulMethods, ApprovalMode, QuotationStatus,
    TestRunPeroid, StockTakeStatus, RawLeadStatus, NoSales, BoundaryTypes, StatusName, StatusClass, ChatEvents, ChatInvoke
}
